import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SavedProvider } from "./context/SavedContext";
import { I18nProvider } from "./i18n/I18nProvider";
import Landing from "./pages/Landing";
import Marketplace from "./pages/Marketplace";
import ListingDetail from "./pages/ListingDetail";
import AddListing from "./pages/AddListing";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import Machines from "./pages/Machines";
import MachineDetail from "./pages/MachineDetail";
import { InventoryList, InventoryDetail } from "./pages/Inventory";
import { ProjectsList, ProjectDetail } from "./pages/Projects";
import QuickBook from "./pages/QuickBook";
import ListingQuickbook from "./pages/ListingQuickbook";
import Co2eDashboard from "./pages/Co2eDashboard";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import VehiclesOverview from "./pages/vehicles/VehiclesOverview";
import VehiclesList from "./pages/vehicles/VehiclesList";
import VehicleDetail from "./pages/vehicles/VehicleDetail";
import VehicleInspections from "./pages/vehicles/Inspections";
import VehicleServices from "./pages/vehicles/Services";
import VehicleCo2Reports from "./pages/vehicles/Co2Reports";
import VehicleDocuments from "./pages/vehicles/VehicleDocuments";
import Trailers from "./pages/vehicles/Trailers";
import RentalReports from "./pages/vehicles/RentalReports";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/listings/new" element={<AddListing />} />
      <Route path="/listings/:id/edit" element={<AddListing />} />
      <Route path="/listings/:id" element={<ListingDetail />} />
      <Route path="/machines" element={<Machines />} />
      <Route path="/machines/:id" element={<MachineDetail />} />
      <Route path="/machines/:id/quickbook" element={<QuickBook />} />
      <Route path="/listings/:id/quickbook" element={<ListingQuickbook />} />
      <Route path="/inventory" element={<InventoryList />} />
      <Route path="/inventory/:id" element={<InventoryDetail />} />
      <Route path="/projects" element={<ProjectsList />} />
      <Route path="/projects/:id" element={<ProjectDetail />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dashboard/co2e" element={<Co2eDashboard />} />
      <Route path="/vehicles" element={<VehiclesOverview />} />
      <Route path="/vehicles/list" element={<VehiclesList />} />
      <Route path="/vehicles/inspections" element={<VehicleInspections />} />
      <Route path="/vehicles/services" element={<VehicleServices />} />
      <Route path="/vehicles/co2" element={<VehicleCo2Reports />} />
      <Route path="/vehicles/documents" element={<VehicleDocuments />} />
      <Route path="/vehicles/trailers" element={<Trailers />} />
      <Route path="/vehicles/rental-reports" element={<RentalReports />} />
      <Route path="/vehicles/:id" element={<VehicleDetail />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <SavedProvider>
              <AppRouter />
            </SavedProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
